import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Button } from "@/Components/ui";
;
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast, { Toaster } from 'react-hot-toast';
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_OPTIONS_LIST, API_RESERVATIONS_OPTIONS, API_RESERVATIONS_OPTIONS_ALL, API_RESERVATIONS_OPTIONS_TOTAL, API_RESERVATION_ALL, BACKEND_HOST, changeReservationState, deleteReservationOption, getDataFromUrl, postData, } from "../../../api";
import moment from "moment";
import QueryString from "qs";
import DeleteOrRefundModal from "../../../Components/Common/DeleteOrRefundModal";
import RefundModal from "../../../Components/Common/RefundModal";
import InlineFilterSelect from "../../../Components/Common/InlineFilterSelect";
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import { dialogService } from "@/utils/dialogService";
import { buildServerListUrl } from "@/utils/serverListQuery";
function printDiv(elid) {
    var divContents = document.getElementById(elid).innerHTML;
    var a = window.open("", "", "height=700, width=500");
    a.document.write("<html>");
    a.document.write('<body><table class="custom-header-css table">');
    a.document.write(divContents);
    // console.log(divContents)
    a.document.write("</table></body></html>");
    a.document.close();
    a.print();
}
const ReservationOptionList = () => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const [refundModalData, setRefundModalData] = useState(null);
    const [productOptions, setProductOptions] = React.useState([]);
    const [reservationOptionsTotal, setReservationOptionsTotal] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => {
            console.log(e);
        });
        if (_url.split("?").length && _url.split("?")[1]) {
            getDataFromUrl(_url.replace(API_RESERVATIONS_OPTIONS, API_RESERVATIONS_OPTIONS_TOTAL))
                .then((data) => {
                console.log(data);
                setReservationOptionsTotal(data);
            })
                .catch((e) => {
                console.log(e);
            });
        }
        else {
            setReservationOptionsTotal({});
        }
    };
    const refetch = useCallback(() => {
        const _q = QueryString.stringify(dataQuery);
        console.log("refetch query:", _q, dataQuery);
        onRequestData(buildServerListUrl(API_RESERVATIONS_OPTIONS, dataQuery));
    }, [dataQuery]);
    React.useEffect(() => {
        if (!previous && !next) {
            refetch();
        }
        getDataFromUrl(API_OPTIONS_LIST).then((data) => {
            setProductOptions(data);
        }).catch((e) => {
            console.log(e);
        });
    }, []);
    const handleChangeReservOption = useCallback(async (id, state) => {
        const _data = await postData(`${BACKEND_HOST}/package/change-reservation-option/${id}/`, { state }, "PUT");
        return _data;
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = React.useState(false);
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
                setCheckedRecords([ele.value, ...checkedRecords]);
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
                setCheckedRecords([]);
            });
        }
    };
    const onClickDelete = (order) => {
        setCheckedRecords([order]);
        setDeleteModal(true);
    };
    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        const recordId = event.target.value;
        if (isChecked) {
            setCheckedRecords([recordId, ...checkedRecords]);
        }
        else {
            const updatedRecords = checkedRecords.filter((id) => id !== recordId);
            setCheckedRecords(updatedRecords);
        }
    };
    useEffect(() => {
        console.log("checkedRecords", checkedRecords);
    }, [checkedRecords]);
    const handleDeleteOrder = () => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                deleteReservationOption(value)
                    .then(async (data) => {
                    console.log("deleteReservationItem:", data);
                    if (data.error) {
                        await dialogService.handleAlert("요청실패:" + data.error);
                        return;
                    }
                    refetch();
                })
                    .catch(async (e) => {
                    await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    const handleRefundOrder = async (option_id, reserv_id, is_complete) => {
        const data = await postData(`${BACKEND_HOST}/package/cancel-reservation-options/`, {
            reserv_options: [{ id: option_id }],
        }, "POST");
        console.log("reservation option refunded", data);
        if (is_complete) {
            const result = await changeReservationState(reserv_id, "완료");
            console.log("reservation state changed", result);
        }
        // .then(data => {
        //     console.log("reservation option refunded", data)
        //     updateData()
        // })
        // .catch(e => console.log("Error while refund reservation option...", e))
        refetch();
    };
    const [showOptions, setShowOptions] = useState(false);
    const toggleShowOptions = () => {
        setShowOptions(!showOptions);
    };
    const [targetCell, setTargetCell] = useState(null);
    const handleCheckedboxUse = () => {
        const checkboxes = document.querySelectorAll(".optionCheckbox");
        // checkboxes.forEach((checkbox) => {
        //   if (checkbox.checked) {
        //     handleChangeReservOption(checkbox.value, "사용함");
        //   }
        //   refetch();
        // });
        const promises = [];
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                promises.push(handleChangeReservOption(checkbox.value, "사용함"));
            }
        });
        Promise.all(promises).then((data) => {
            console.log("reservation option updated", data);
            refetch();
        }).catch((e) => console.log("Error while update reservation option...", e));
    };
    const handleCheckedboxNotuse = () => {
        const checkboxes = document.querySelectorAll(".optionCheckbox");
        // checkboxes.forEach((checkbox) => {
        //   if (checkbox.checked) {
        //     handleChangeReservOption(checkbox.value, "사용안함");
        //   }
        // });
        // refetch();
        // use promise all
        const promises = [];
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                promises.push(handleChangeReservOption(checkbox.value, "사용안함"));
            }
        });
        Promise.all(promises).then((data) => {
            console.log("reservation option updated", data);
            refetch();
        }).catch((e) => console.log("Error while update reservation option...", e));
    };
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input optionCheckbox" value={cellProps.row.original.id}/>;
            },
            id: "#",
        },
        {
            Header: "ID",
            accessor: "id",
            id: "id",
        },
        {
            Header: "예약신청일",
            accessor: "예약신청일",
            id: "order_date",
            Cell: (cellProps) => {
                return <span>{moment(cellProps.row.original["예약신청일"]).format("YYYY-MM-DD HH:mm")}</span>;
            },
        }, //end_date, id, options, order, order_id, review, spot, spot_id, start_date
        {
            Header: "예약상품",
            accessor: "name",
            id: "name",
        },
        {
            Header: "가격",
            accessor: "price",
            id: "price",
        },
        {
            Header: "예약자",
            accessor: "username",
            id: "username",
        },
        {
            Header: "번호",
            accessor: "phone_num",
            id: "phone_num",
        },
        {
            Header: "패키지",
            accessor: "reserv_package",
            id: "reserv_package",
        },
        {
            Header: "자리",
            accessor: "reserv_spot",
            id: "reserv_spot",
        },
        {
            Header: "예약시작일",
            accessor: "reserv_start_date",
            id: "reserv_start_date",
        },
        {
            Header: "예약종료일",
            accessor: "reserv_end_date",
            id: "reserv_end_date",
        },
        {
            Header: "예약상태",
            accessor: "reserv_state",
            id: "reserv_state",
        },
        {
            Header: "사용상태",
            accessor: "state",
            id: "state",
        },
        {
            Header: "면세여부",
            accessor: "tax_free",
            id: "tax_free",
            // Cell: (cellProps) => {
            //   return <span>{cellProps.row.original["tax_free"]}</span>;
            // },
        },
        {
            Header: "Actions",
            accessor: "Actions",
            id: "",
            Cell: (cellProps) => {
                return (<div className="d-flex flex-row justify-content-end align-items-end gap-2">
              <Button color={cellProps.row.original.state === "사용함" ? "danger" : "primary"} style={{ marginRight: "15px" }} size="sm" onClick={() => {
                        handleChangeReservOption(cellProps.row.original.id, cellProps.row.original.state === "사용함" ? "사용안함" : "사용함")
                            .then((data) => {
                            console.log("reservation option updated", data);
                            refetch();
                        })
                            .catch((e) => console.log("Error while update reservation option...", e));
                    }}>
                {cellProps.row.original.state === "사용함" ? "사용취소" : "사용처리"}
              </Button>
              <div className="remove align-self-center">
                <div className="text-danger" style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => {
                        setRefundModalData({
                            id: cellProps.row.original.id,
                            name: cellProps.row.original.name,
                            price: cellProps.row.original.price,
                            type: cellProps.row.original.type,
                            state: cellProps.row.original.state,
                            reservId: cellProps.row.original.reserv_id,
                        });
                        // console.log("cellProps.row.original", cellProps.row.original);
                        onClickDelete(cellProps.row.original.id);
                    }}>
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </div>
              </div>
            </div>);
            },
        },
    ], [dataQuery, handleChangeReservOption]);
    return (<div className="page-content">
      {/* <DeleteOrRefundModal
          show={deleteModal}
          onDeleteClick={handleDeleteOrder}
          onCloseClick={() => setDeleteModal(false)}
          onRefundClick={handleRefundOrder}
          itemPrice={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["결제금액"] : 0}
        /> */}
      <RefundModal show={deleteModal} onCloseClick={() => setDeleteModal(false)} data={refundModalData} onRefundClick={() => {
            if (refundModalData) {
                const { id, reservId } = refundModalData;
                handleRefundOrder(id, reservId, false).then(() => {
                    setDeleteModal(false);
                });
            }
        }} onRefundCompleteClick={() => {
            if (refundModalData) {
                const { id, reservId } = refundModalData;
                handleRefundOrder(id, reservId, true).then(() => {
                    setDeleteModal(false);
                });
            }
        }}/>
      <DeleteModal show={deleteModalMulti} onDeleteClick={() => {
            handleDeleteOrder();
        }} onCloseClick={() => setDeleteModalMulti(false)}/>

      <Modal isOpen={showOptions} onClose={toggleShowOptions} centered={true}>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-left">
            <div className="mt-4 pt-2 fs-15 mx-sm-5">
              <h4>예약상세</h4>
              {targetCell && (<div className="mt-4">
                  <p className="text-muted mb-0">예약상품: {targetCell["예약상품"]}</p>
                  <p className="text-muted mb-0">자리: {targetCell["자리"]}</p>
                  <p className="text-muted mb-0">예약자: {targetCell["예약자"]}</p>
                  <p className="text-muted mb-0">예약시작일: {targetCell["예약시작일"]}</p>
                  <p className="text-muted mb-0">예약종료일: {targetCell["예약종료일"]}</p>
                  <p className="text-muted mb-0">예약상태: {targetCell["예약상태"]}</p>
                  <p className="text-muted mb-0">결제금액: {targetCell["결제금액"]}</p>
                </div>)}
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <Button type="button" data-bs-dismiss="modal" onClick={() => {
            setShowOptions(false);
        }} color="light">
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Container fluid>
        <BreadCrumb title="옵션구매관리" pageTitle="옵션"/>
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">옵션 구매 목록</h5>
                  <div className="flex-shrink-0">
                    <Button color="primary" className="add-btn me-1" onClick={() => {
            handleCheckedboxUse();
        }} id="create-btn">
                      선택 사용 처리
                    </Button>
                    <Button color="danger" className="add-btn me-1" onClick={() => {
            handleCheckedboxNotuse();
        }} id="create-btn">
                      선택 사용 취소
                    </Button>
                    <Button onClick={async () => {
            await dialogService.handleAlert("액셀 파일을 다운로드합니다... 건수가 400건이 넘을 경우 파일에 누락될 수 있으니 유의하시기 바랍니다.");
            getDataFromUrl(`${API_RESERVATIONS_OPTIONS_ALL}/?${QueryString.stringify(dataQuery)}`).then((data) => {
                // const rows = data.map(row => ({
                // // id	예약신청일	예약상품	자리	예약자	번호	예약시작일	이용기간	예약상태	결제상태	승인번호
                // }));
                const worksheet = utils.json_to_sheet(data);
                const workbook = utils.book_new();
                utils.book_append_sheet(workbook, worksheet, "id");
                writeFileXLSX(workbook, "output.xlsx");
            });
            // const worksheet = utils.table_to_sheet(document.getElementById('reservations-table'))
            // const workbook = utils.book_new()
            // utils.book_append_sheet(workbook, worksheet)
            // writeFileXLSX(workbook, "output.xlsx")
            // writeFile(workbook, "output.csv")
        }} color="soft">
                      <i className="ri-save-2-line"></i>
                    </Button>
                    <span style={{ padding: "4px" }}></span>
                    <Button onClick={() => {
            printDiv("reservations-option-table");
        }} color="soft">
                      <i className="ri-printer-line"></i>
                    </Button>
                    <span style={{ padding: "4px" }}></span>
                    {/* <Button  onClick={() => setDeleteModalMulti(true)} color="soft-danger">
          <i className="ri-delete-bin-2-line"></i>
        </Button> */}
                  </div>
                </div>
              </CardHeader>

              <CardBody className="pt-0">
                <div className="card-body pt-0">
                  <div className="mb-3">
                    <div className="mb-3">
                      <Label htmlFor="date-field" className="form-label">
                        예약날짜
                      </Label>
                      <div className="d-flex">
                        <CommonDatePicker id="date-field" className="form-control" size={"32px"} options={{
        }} placeholder="Select Date" value={dataQuery["date"] || ""} onChange={(value) => {
            setDataQuery(prev => ({
                ...dataQuery,
                date: moment(value[0]).format("YYYY-MM-DD"),
            }));
            const _q = QueryString.stringify({ ...dataQuery, date: moment(value[0]).format("YYYY-MM-DD") });
            onRequestData(`${API_RESERVATIONS_OPTIONS}/?${_q}`);
        }}/>
                        <div style={{ width: "10px" }}></div>
                        <div className="btn btn-primary btn-sm d-flex align-items-center" onClick={() => {
            setDataQuery(prev => ({
                ...dataQuery,
                date: undefined,
            }));
            const _q = QueryString.stringify({ ...dataQuery, date: undefined });
            onRequestData(`${API_RESERVATIONS_OPTIONS}/?${_q}`);
        }}>Clear</div>
                      </div>
                    </div>
                    <InlineFilterSelect label="사용상태" selectedValue={dataQuery["state"] || undefined} selectOptions={[
            { value: undefined, label: "전체" },
            { value: "사용함", label: "사용함" },
            { value: "사용안함", label: "사용안함" },
        ]} onFilterChange={(value) => {
            setDataQuery({ ...dataQuery, state: value });
            const _q = QueryString.stringify({ ...dataQuery, state: value });
            onRequestData(`${API_RESERVATIONS_OPTIONS}/?${_q}`);
        }}/>
                    <div style={{ height: "10px" }}></div>
                    <InlineFilterSelect label="옵션상품" selectedValue={dataQuery["option_id"] || undefined} selectOptions={[
            { value: undefined, label: "전체" },
            // { value: "1", label: "test1" },
            // { value: "2", label: "test2" },
            ...productOptions.map((item) => ({ value: item.id, label: item.name })),
        ]} onFilterChange={(value) => {
            setDataQuery({ ...dataQuery, option_id: value });
            const _q = QueryString.stringify({ ...dataQuery, option_id: value });
            onRequestData(`${API_RESERVATIONS_OPTIONS}/?${_q}`);
        }}/>
                    <div style={{ height: "10px" }}></div>
                    {Object.keys(reservationOptionsTotal).length ? <div>
                      <table className="table table-bordered table-hover table-centered mb-0">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>옵션상품</th>
                            <th style={{ textAlign: "center" }}>사용</th>
                            <th style={{ textAlign: "center" }}>미사용</th>
                            <th style={{ textAlign: "center" }}>전체</th>
                            <th style={{ textAlign: "center" }}>총액</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(reservationOptionsTotal).map((key) => {
                return (<tr key={key}>
                                <td>{key}</td>
                                <td style={{ textAlign: "right" }}>{reservationOptionsTotal[key].used}</td>
                                <td style={{ textAlign: "right" }}>{reservationOptionsTotal[key].count - reservationOptionsTotal[key].used}</td>
                                <td style={{ textAlign: "right" }}>{reservationOptionsTotal[key].count}</td>
                                <td style={{ textAlign: "right" }}>{new Intl.NumberFormat().format(reservationOptionsTotal[key].total)}원</td>
                              </tr>);
            })}
                          <tr key={"total"}>
                            <td style={{ fontWeight: "bold" }}>합계</td>
                            <td style={{ fontWeight: "bold", textAlign: "right" }}>{new Intl.NumberFormat().format(Object.keys(reservationOptionsTotal).reduce((acc, cur) => acc + reservationOptionsTotal[cur].used, 0))}</td>
                            <td style={{ fontWeight: "bold", textAlign: "right" }}>{new Intl.NumberFormat().format(Object.keys(reservationOptionsTotal).reduce((acc, cur) => acc + reservationOptionsTotal[cur].count, 0))
                - new Intl.NumberFormat().format(Object.keys(reservationOptionsTotal).reduce((acc, cur) => acc + reservationOptionsTotal[cur].used, 0))}</td>
                            <td style={{ fontWeight: "bold", textAlign: "right" }}>{new Intl.NumberFormat().format(Object.keys(reservationOptionsTotal).reduce((acc, cur) => acc + reservationOptionsTotal[cur].count, 0))}</td>

                            <td style={{ fontWeight: "bold", textAlign: "right" }}>{new Intl.NumberFormat().format(Object.keys(reservationOptionsTotal).reduce((acc, cur) => acc + reservationOptionsTotal[cur].total, 0))}원</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
            : <span>
                        필터를 선택하면 예약상품별 총액이 표시됩니다.
                      </span>}
                  </div>
                  <div>
                    <React.Fragment>
                      <ServerPaginatedTable id="reservations-option-table" url={API_RESERVATIONS_OPTIONS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[
        // { id: 0, title: "전체", state: undefined, icon: "ri-store-2-fill" },
        // { id: 1, title: "사용함", state: "사용함", icon: "ri-checkbox-circle-line" },
        // { id: 2, title: "사용안함", state: "사용안함", icon: "ri-more-fill" },
        ]}/>
                    </React.Fragment>
                  </div>
                </div>

                <Toaster position="top-center"/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>);
};
export default ReservationOptionList;
